import urls from '../app/urls';
import { getItemPositionInPatientProgram, getItemPositionInProgram, parseInternalLink } from '../youwell-common/taskContentUtils';

export const getProgramContentLink = (link, program) => {
    const { taskOrModuleId, hash } = parseInternalLink(link);
    const { elementGroup, elementIndex, taskIndex } = getItemPositionInPatientProgram(program, taskOrModuleId);

    if (elementGroup && elementIndex > -1 && taskIndex > -1) {
        return `${urls.inside.program}/${elementGroup}/${elementIndex}/${taskIndex}${hash}`;
    }
    if (elementGroup && elementIndex > -1) {
        return `${urls.inside.program}/${elementGroup}/${elementIndex}${hash}`;
    }
    return `${urls.inside.programLink}/${taskOrModuleId}${hash}`;
};

export const getPublicProgramContentLink = (link, program) => {
    const { taskOrModuleId, hash } = parseInternalLink(link);
    const { moduleIndex, taskIndex } = getItemPositionInProgram(program, taskOrModuleId);

    if (moduleIndex > -1 && taskIndex > -1) { // link is to taskId
        return `${urls.public.program}/${program.id}/${moduleIndex}/${taskIndex}${hash}`;
    }
    if (moduleIndex > -1) { // link is to moduleId
        return `${urls.public.program}/${program.id}/${taskOrModuleId}${hash}`;
    }
    return `${urls.public.programLink}/${taskOrModuleId}${hash}`;
};
